import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isSheetFromAddSong, searchWithoutSheetSong, smartLinkSheetSongOf } from './smartLinkSheetSong';

/**
 * The catalog song that `?catalogItemUuid=` asks the SmartLinks page to open the creation sheet on,
 * `isFromAddSong` (`&from=addSong`: the page is published at once), and `clear`, which takes both
 * values out of the address (replace, no new history entry).
 */
export function useSmartLinkSheetSong(): {
  catalogItemUuid: string | undefined;
  isFromAddSong: boolean;
  clear: () => void;
} {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const catalogItemUuid = useMemo(() => smartLinkSheetSongOf(pathname, search), [pathname, search]);
  const isFromAddSong = useMemo(() => isSheetFromAddSong(pathname, search), [pathname, search]);
  const clear = useCallback(() => {
    // eslint-disable-next-line no-void
    void navigate(`${pathname}${searchWithoutSheetSong(search)}`, { replace: true });
  }, [navigate, pathname, search]);
  return { catalogItemUuid, isFromAddSong, clear };
}
